const REDACTED = "[Filtered]";

const SENSITIVE_KEY_PATTERN =
  /(?:authorization|cookie|token|secret|password|passwd|credential|access[_-]?token|refresh[_-]?token|id[_-]?token|session|connection[_-]?id|project[_-]?path|repo(?:sitory)?[_-]?path|branch|pipeline[_-]?id|job[_-]?name|source[_-]?name|parser|oauth|code|state)/i;

const TOKEN_VALUE_PATTERNS = [
  /\bBearer\s+[^\s,;]+/gi,
  /\bglpat-[A-Za-z0-9_-]+\b/g,
  /\bgithub_pat_[A-Za-z0-9_]+\b/g,
  /\bgh[opsru]_[A-Za-z0-9_]+\b/g,
  /\bsntrys_[A-Za-z0-9+/=_-]+\b/g,
  /\bxox[baprs]-[A-Za-z0-9-]+\b/g,
];

const EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const REPO_PAIR_PATTERN = /\b[A-Za-z0-9_.-]+\/[A-Za-z0-9_.-]+\b/g;

function scrubString(value: string): string {
  const urlScrubbed = stripFullUrlSearchAndHash(value);
  if (urlScrubbed) {
    return redactTokenAndEmailSubstrings(urlScrubbed);
  }

  let scrubbed = stripInlineSensitiveQueryParams(value);
  scrubbed = redactTokenAndEmailSubstrings(scrubbed);
  scrubbed = scrubbed.replace(REPO_PAIR_PATTERN, "project");
  return scrubbed;
}

function redactTokenAndEmailSubstrings(value: string): string {
  let scrubbed = value;
  for (const pattern of TOKEN_VALUE_PATTERNS) {
    scrubbed = scrubbed.replace(pattern, REDACTED);
  }

  scrubbed = scrubbed.replace(EMAIL_PATTERN, REDACTED);
  return scrubbed;
}

function stripFullUrlSearchAndHash(value: string): string | null {
  const match = value.match(/^([a-z][a-z0-9+.-]*:\/\/[^/?#\s]+[^?#\s]*)(?:[?#]\S*)?$/i);
  return match?.[1] ?? null;
}

function stripInlineSensitiveQueryParams(value: string): string {
  return value.replace(
    /([?&](?:code|state|token|access_token|refresh_token|id_token)=)[^&#\s]+/gi,
    `$1${REDACTED}`
  );
}

function shouldScrubKey(key: string): boolean {
  return SENSITIVE_KEY_PATTERN.test(key);
}

function scrubValue(value: unknown, seen: WeakSet<object>): unknown {
  if (typeof value === "string") {
    return scrubString(value);
  }
  if (value === null || typeof value !== "object") {
    return value;
  }
  if (seen.has(value)) {
    return REDACTED;
  }
  seen.add(value);

  if (Array.isArray(value)) {
    return value.map((entry) => scrubValue(entry, seen));
  }

  const output: Record<string, unknown> = {};
  for (const [key, entry] of Object.entries(value)) {
    output[key] = shouldScrubKey(key) ? REDACTED : scrubValue(entry, seen);
  }
  return output;
}

export function scrubSentryEvent<T>(event: T): T {
  return scrubValue(event, new WeakSet<object>()) as T;
}
